export default __webpack_public_path__ + "static/media/anas.0150ec97.jpg";